module.exports = __webpack_public_path__ + "img/ctrl-pauli-y-root-stub-1.71f5f81c.svg";